const CustCommPlan = () => import('@/views/main/report/custCommPlan/CustCommPlan.vue')
export default {
  path: '/main/report/custCommPlan',
  name: 'custCommPlan',
  component: CustCommPlan,
  children: []
}
